import { Coupon, CouponPayload, CouponsResponse } from '@/@types/Coupons';
import { api } from './api';

/** Alguns cupons nascem com aviso da API (ex.: percentual sem oferta vinculada). */
export interface CouponMutationResponse {
  data: Coupon;
  warning?: string | null;
}

export class CouponsService {
  static async getCoupons({
    productId,
    page,
  }: {
    productId: string;
    page: number;
  }): Promise<CouponsResponse> {
    const response = await api.get(
      `/v1/products/${productId}/coupons?page=${page}`
    );

    return response.data;
  }

  static async createCoupon({
    productId,
    data,
  }: {
    productId: string;
    data: CouponPayload;
  }): Promise<CouponMutationResponse> {
    const response = await api.post(
      `/v1/products/${productId}/coupons`,
      data
    );

    return response.data;
  }

  static async updateCoupon({
    productId,
    couponId,
    data,
  }: {
    productId: string;
    couponId: string;
    data: CouponPayload;
  }): Promise<CouponMutationResponse> {
    const response = await api.put(
      `/v1/products/${productId}/coupons/${couponId}`,
      data
    );

    return response.data;
  }

  static async deleteCoupon({
    productId,
    couponId,
  }: {
    productId: string;
    couponId: string;
  }): Promise<void> {
    await api.delete(`/v1/products/${productId}/coupons/${couponId}`);
  }

  /**
   * Cotação comercial "1 `from` = `rate` `to`" — a mesma fonte (Nexus) que o
   * checkout usa para converter o cupom na hora da compra.
   */
  static async getCurrencyRate({
    from,
    to,
  }: {
    from: string;
    to: string;
  }): Promise<number> {
    const response = await api.get<{ rate: number }>(
      `/v1/currencies/rate?from=${from}&to=${to}`
    );

    return response.data.rate;
  }
}
